import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bookdaundtoshirdixabonhire() {



  const cardData =
  {
    keyword: 'Book Daund to Shirdi Cab on Hire',
    heading: 'Sanavi Travels: Book Daund to Shirdi Cab on Hire',
    headingDescription: 'Sanavi Travels makes it easy to book Daund to Shirdi cab on hire, offering safe, comfortable, and reliable transportation for pilgrims, families, and groups traveling to the holy town of Shirdi. Our fleet of well-maintained hatchbacks, sedans, SUVs, and premium cabs ensures smooth rides, air-conditioning, and ample luggage space for a peaceful journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, hassle-free, and stress-free travel. We provide convenient doorstep pickup from Daund and nearby areas with smooth drop-offs at Sai Baba Temple, hotels, and key locations in Shirdi. Choose Sanavi Travels to book your Daund to Shirdi cab on hire, ensuring comfort, safety, and a seamless pilgrimage experience.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "The Shirdi Sai Baba Temple is one of India’s most revered pilgrimage sites, dedicated to Sai Baba, the saint who preached faith, patience, and equality. Millions of devotees visit the temple every year to seek blessings, attend aarti ceremonies, and experience deep spiritual peace. The temple complex is well-organized with darshan halls, meditation areas, and facilities for devotees."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is a sacred mosque where Sai Baba spent a significant part of his life. The dhuni (sacred fire) lit by Sai Baba still burns here, symbolizing faith and protection. Devotees believe that wishes made here are fulfilled through Baba’s blessings."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi holds historical importance as the place where Sai Baba used to sleep on alternate nights. The ceremonial procession from Dwarkamai to Chavadi on Thursdays recreates Baba’s routine and attracts many devotees."
  },
  {
    "title": "Samadhi Mandir",
    "description": "The Samadhi Mandir houses the mortal remains of Sai Baba. Built in white marble, the sanctum radiates peace and devotion. Devotees offer prayers and flowers, experiencing a strong spiritual connection with Sai Baba."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden where Sai Baba used to meditate. It features the sacred Nanda Deep lamp and Neem tree, creating a serene atmosphere ideal for reflection and devotion."
  },
  {
    "title": "Khandoba Temple",
    "description": "The Khandoba Temple is where Sai Baba was first welcomed into Shirdi by Mahalsapati. This small but significant shrine marks the beginning of Sai Baba’s spiritual journey in Shirdi."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village recreates the life and era of Sai Baba through statues, exhibits, and village settings. It offers devotees insight into Baba’s teachings and the lifestyle of his times."
  },
  {
    "title": "Abdul Baba Cottage",
    "description": "This cottage is associated with Abdul Baba, a close devotee of Sai Baba. It reflects the harmony between different faiths, which Sai Baba strongly preached throughout his life."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan is believed to be the place under a neem tree where Sai Baba was first seen meditating. It is considered highly auspicious, and devotees light incense and offer prayers here."
  },
  {
    "title": "Local Markets and Prasad Shops",
    "description": "The bustling markets around Shirdi offer prasad, religious souvenirs, books, and handicrafts. These markets add to the pilgrimage experience and allow devotees to take home sacred mementos."
  }
]
,



"services": [
    {
      "name": "Book Daund to Shirdi Cab on Hire",
      "description": "Book Daund to Shirdi Cab on Hire offers reliable and comfortable taxi services for travelers visiting Shirdi. Well-maintained vehicles and professional drivers ensure a safe, smooth, and timely journey."
    },
    {
      "name": "Daund Shirdi Cab Booking",
      "description": "Daund Shirdi Cab Booking provides easy and hassle-free cab reservations for Shirdi travel. Flexible pickup options, transparent pricing, and prompt service make travel convenient for all passengers."
    },
    {
      "name": "AC Cab Daund to Shirdi",
      "description": "AC Cab Daund to Shirdi ensures a comfortable and refreshing journey with air-conditioned vehicles. Ideal for families, senior citizens, and devotees seeking a relaxed travel experience."
    },
    {
      "name": "Affordable Cab Shirdi",
      "description": "Affordable Cab Shirdi offers budget-friendly taxi services without compromising on comfort or safety. Suitable for solo travelers, families, and group trips to Shirdi."
    },
    {
      "name": "Chauffeur Driven Cab Shirdi",
      "description": "Chauffeur Driven Cab Shirdi provides professional drivers who handle navigation and traffic, ensuring a stress-free and pleasant journey for pilgrims and tourists."
    },
    {
      "name": "Best Cab Daund to Shirdi",
      "description": "Best Cab Daund to Shirdi guarantees punctual service, clean vehicles, and experienced drivers, making it a preferred choice for comfortable and reliable Shirdi travel."
    },
    {
      "name": "One Way Cab Shirdi",
      "description": "One Way Cab Shirdi is ideal for travelers looking for convenient single-drop taxi services from Daund to Shirdi at competitive rates."
    },
    {
      "name": "Round Trip Cab Shirdi",
      "description": "Round Trip Cab Shirdi offers flexible return travel options, perfect for devotees planning overnight stays or extended visits to Shirdi."
    },
    {
      "name": "Family Cab Shirdi",
      "description": "Family Cab Shirdi provides spacious and comfortable cabs suitable for family travel, ensuring safety and convenience for all age groups."
    },
    {
      "name": "Tourist Cab Shirdi",
      "description": "Tourist Cab Shirdi caters to travelers exploring Shirdi and nearby attractions, offering flexible itineraries and experienced drivers for a memorable trip."
    },
    {
      "name": "Online Cab Booking Daund",
      "description": "Online Cab Booking Daund allows quick and easy booking of Shirdi cabs with instant confirmation, multiple vehicle options, and flexible scheduling."
    },
    {
      "name": "Railway Pickup Cab",
      "description": "Railway Pickup Cab provides timely pickup and drop services from Daund railway station, ensuring seamless connectivity for Shirdi-bound travelers."
    },
    {
      "name": "Sai Darshan Cab",
      "description": "Sai Darshan Cab offers dedicated taxi services for devotees visiting Sai Baba temple, ensuring a comfortable and spiritually focused travel experience."
    },
    {
      "name": "Outstation Cab Daund",
      "description": "Outstation Cab Daund provides reliable long-distance taxi services for Shirdi and other destinations, combining comfort, safety, and affordability."
    },
    {
      "name": "Shirdi Travel Taxi",
      "description": "Shirdi Travel Taxi delivers comprehensive cab services for pilgrims and tourists, ensuring smooth travel, professional drivers, and well-maintained vehicles."
    }
  ],
  "tableData": [
    ["Book Daund to Shirdi Cab on Hire", "Daund Shirdi Cab Booking"],
    ["AC Cab Daund to Shirdi", "Affordable Cab Shirdi"],
    ["Chauffeur Driven Cab Shirdi", "Best Cab Daund to Shirdi"],
    ["One Way Cab Shirdi", "Round Trip Cab Shirdi"],
    ["Family Cab Shirdi", "Tourist Cab Shirdi"],
    ["Online Cab Booking Daund", "Railway Pickup Cab"],
    ["Sai Darshan Cab", "Outstation Cab Daund"],
    ["Shirdi Travel Taxi", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Book Daund to Shirdi Cab on Hire with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab hire services from Daund to Shirdi, ideal for pilgrimage travelers, families, and small groups."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Our cabs are clean, air-conditioned, and regularly serviced, ensuring a smooth and comfortable journey from Daund to Shirdi."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with the Daund to Shirdi route, ensuring safe, timely, and smooth travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Daund to Shirdi cab hire, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Daund to Shirdi trip."
  },
  {
    "WhyChooseheading": "Flexible Cab Rental Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab hire packages based on your travel schedule and needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Shirdi cab hire."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab hire services from Daund to Shirdi?',
    answer: 'Yes, Sanavi Travels offers reliable cab hire services for travel from Daund to Shirdi.'
  },
  {
    question: 'How can I book a cab from Daund to Shirdi?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available from Daund to Shirdi?',
    answer: 'Sanavi Travels offers Hatchback, Sedan, SUV, and Tempo Traveller options for Daund to Shirdi cab hire.'
  },
  {
    question: 'Are the drivers experienced with the Daund to Shirdi route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Daund to Shirdi route.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Daund and drop-off location in Shirdi.'
  },
  {
    question: 'Is the cab service from Daund to Shirdi available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services from Daund to Shirdi.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Shirdi cab trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Kulkarni',
    feedback: 'Booked a cab from Daund to Shirdi with Sanavi Travels. Comfortable ride, polite driver, and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Pawar',
    feedback: 'Sanavi Travels made our Daund to Shirdi pilgrimage smooth and stress-free. Highly recommended cab service.',
    rating: 5
  }
];






































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Daund to Shirdi Cab on Hire - Sanavi Travels",
  "description": "Sanavi Travels provides AC and chauffeur-driven cabs from Daund to Shirdi for Sai Baba Darshan, family trips, and tourist travel. Affordable, reliable, one-way and round-trip cab options with easy online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "55"
  }
};








  return (
    <div>
<Helmet>
  <title>
    Book Daund to Shirdi Cab on Hire | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC and chauffeur-driven cabs from Daund to Shirdi for Sai Baba Darshan, family trips, and tourist travel. Affordable, reliable, one-way and round-trip cab options with easy online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/125.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bookdaundtoshirdixabonhire;